export const productsPlan = {
    "tvi": [
        {
            id: "prod_NscGBuXgygyhjA",
            name: "TripValet Incentives Monthly",
            price: "price_1N6r28IB7ByDDUZGgeza8yoE"
        },
        {
            id: "prod_NscIlsJ9eMROmo",
            name: "TVI 3 Month Membership",
            price: "price_1N6r4NIB7ByDDUZGUooyFuye"
        },
        {
            id: "prod_NscJ6xruBfJBfn",
            name: "TVI 6 Month Membership",
            price: "price_1N6r5JIB7ByDDUZGYog3q7ew"
        },
        {
            id: "prod_NscKu3yQbLAvu3",
            name: "TVI 12 Month Membership",
            price: "price_1N6r5qIB7ByDDUZGycdREpu1"
        }
    ],
    "tv": [
        {
            id: "prod_Nn2s0R15jQje27",
            name: "TripValet Annual",
            price: "price_1N1SmqDfGKjcFXEHBXw6bOX0"
        },
        {
            id: "prod_Nn2qbv5yEEQTMv",
            name: "TripValet Monthly",
            price: "price_1N1SlIDfGKjcFXEH9KvWhWmR"
        }
    ]

}

